import { ErroDaApi, ErroDeRede } from "@plantus/api-client";

/**
 * Traduz a recusa da API em texto para a tela.
 *
 * <p><b>A tela nunca diz mais que a API.</b> O backend se dá ao trabalho
 * de responder exatamente a mesma coisa — e no mesmo tempo — para
 * "e-mail não existe" e "senha errada", justamente para não revelar quem
 * tem conta no sistema. Uma mensagem específica demais aqui desfaria
 * esse trabalho inteiro do lado do cliente.
 *
 * <p>O bloqueio é a única recusa com texto próprio, e ele não vaza nada:
 * a contagem do backend é pelo e-mail digitado, exista ou não a conta.
 */
export function mensagemDeLogin(erro: unknown): string {
  if (erro instanceof ErroDeRede) {
    return "Não foi possível falar com o servidor. Verifique a conexão e tente de novo.";
  }
  if (erro instanceof ErroDaApi) {
    if (erro.status === 429) {
      return "Muitas tentativas. Aguarde alguns minutos e tente de novo.";
    }
    if (erro.status === 401) {
      return "E-mail ou senha inválidos.";
    }
    if (erro.status === 400) {
      return "Preencha o e-mail e a senha.";
    }
  }
  return "Não foi possível entrar. Tente de novo em instantes.";
}

export function mensagemDeSegundoFator(erro: unknown): string {
  if (erro instanceof ErroDeRede) {
    return "Não foi possível falar com o servidor. Verifique a conexão e tente de novo.";
  }
  if (erro instanceof ErroDaApi && erro.status === 429) {
    // O código também tem bloqueio por tentativas, com contagem própria.
    // Sem esta mensagem, quem foi bloqueado continuaria digitando códigos
    // certos e recebendo "código inválido" — o texto errado sobre o que
    // está acontecendo.
    return "Muitas tentativas. Aguarde alguns minutos e tente de novo.";
  }
  if (erro instanceof ErroDaApi && erro.status === 401) {
    // Sem distinguir "errado" de "já usado": a diferença só interessa a
    // quem investiga, e ela está na trilha.
    return "Código inválido ou já utilizado. Confira o aplicativo e tente de novo.";
  }
  return "Não foi possível confirmar o código. Tente de novo em instantes.";
}
